import { render } from "./Category_management_list.vue?vue&type=template&id=375a9978&scoped=true"
import script from "./Category_management_list.vue?vue&type=script&lang=js"
export * from "./Category_management_list.vue?vue&type=script&lang=js"

import "./Category_management_list.vue?vue&type=style&index=0&id=375a9978&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-375a9978"]])

export default __exports__